import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1f1373aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center mb-8" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Yapay Zeka Asistanı"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row gap-2" })
], -1))
const _hoisted_2 = {
  key: 0,
  class: "flex items-center space-x-4"
}
const _hoisted_3 = { class: "flex flex-row gap-4 h-screen w-full" }
const _hoisted_4 = { class: "w-1/4 p-4 bg-white rounded-md shadow" }
const _hoisted_5 = { class: "text-2xl font-bold mb-4" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "E-mail", -1))
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Yetki", -1))
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Kayıt Tarihi", -1))
const _hoisted_12 = { class: "w-3/4 flex flex-col gap-4" }
const _hoisted_13 = { class: "p-4 bg-white rounded-md shadow" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-4\" data-v-1f1373aa><div class=\"flex items-center\" data-v-1f1373aa><svg class=\"w-12 h-12\" fill=\"url(#grad1)\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1f1373aa><defs data-v-1f1373aa><linearGradient id=\"grad1\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"0%\" data-v-1f1373aa><stop offset=\"0%\" style=\"stop-color:#b794f4;stop-opacity:1;\" data-v-1f1373aa></stop><stop offset=\"50%\" style=\"stop-color:#ed64a6;stop-opacity:1;\" data-v-1f1373aa></stop><stop offset=\"100%\" style=\"stop-color:#f56565;stop-opacity:1;\" data-v-1f1373aa></stop></linearGradient></defs><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0\" d=\"M7 0.714966C6.57172 0.714966 6.19841 1.00644 6.09453 1.42193C5.64458 3.22175 5.11525 4.31311 4.3567 5.07167C3.59815 5.83022 2.50678 6.35955 0.706966 6.8095C0.291477 6.91337 -3.32794e-07 7.28669 -3.32794e-07 7.71497C-3.32794e-07 8.14324 0.291477 8.51656 0.706966 8.62043C2.50678 9.07039 3.59815 9.59971 4.3567 10.3583C5.11525 11.1168 5.64458 12.2082 6.09453 14.008C6.19841 14.4235 6.57172 14.715 7 14.715C7.42828 14.715 7.80159 14.4235 7.90547 14.008C8.35542 12.2082 8.88475 11.1168 9.6433 10.3583C10.4019 9.59971 11.4932 9.07039 13.293 8.62043C13.7085 8.51656 14 8.14324 14 7.71497C14 7.28669 13.7085 6.91337 13.293 6.8095C11.4932 6.35955 10.4019 5.83022 9.6433 5.07167C8.88475 4.31311 8.35542 3.22175 7.90547 1.42193C7.80159 1.00644 7.42828 0.714966 7 0.714966Z\" data-v-1f1373aa></path></svg><h2 class=\"text-lg font-bold pb-4\" data-v-1f1373aa>Yapay Zeka Asistanınız</h2></div></div>", 1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mb-4 relative flex w-full p-3 text-sm border border-orange-200 text-slate-600 rounded-md bg-orange-50" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    class: "h-5 w-5 mr-2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Yapay asistanınızı henüz aktifleştirmediniz.")
], -1))
const _hoisted_17 = { class: "flex justify-end" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex justify-between" }
const _hoisted_20 = {
  key: 0,
  class: "text-2xl font-extrabold text-green-400 pb-4"
}
const _hoisted_21 = {
  key: 1,
  class: "text-2xl font-extrabold text-red-400 pb-4"
}
const _hoisted_22 = { class: "inline-flex items-center cursor-pointer" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-400 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-400" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Assistant Id:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold pt-2" }, "Yapay Zeka Asistanınızı Kişiselleştirin", -1))
const _hoisted_27 = { class: "p-4 bg-white rounded-md shadow" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold pb-4" }, "Kişisel Talimatlar", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold py-4" }, "Davranış Şekli", -1))
const _hoisted_30 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_ctx.Loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.Teacher.name) + " " + _toDisplayString(_ctx.Teacher.surname), 1),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", null, _toDisplayString(_ctx.Teacher.email), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", null, _toDisplayString(_ctx.Teacher.role === 'Admin' ? 'Yönetici' : 'Öğretmen'), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("p", null, _toDisplayString(_ctx.Teacher.createdAt), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                (!_ctx.Assistant.openAiAssistantId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.CreateAssistant && _ctx.CreateAssistant(...args))),
                          class: "rounded-md bg-teal-500 px-6 py-2.5 text-lg font-semibold text-white shadow-sm hover:bg-teal-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        }, " Aktifleştir ")
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (_ctx.Assistant.isActive)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_20, "AKTİF"))
                          : (_openBlock(), _createElementBlock("p", _hoisted_21, "PASİF")),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Assistant.isActive) = $event)),
                              class: "sr-only peer",
                              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.UpdateAssistant && _ctx.UpdateAssistant(...args))),
                              checked: _ctx.Assistant.isActive
                            }, null, 40, _hoisted_23), [
                              [_vModelCheckbox, _ctx.Assistant.isActive]
                            ]),
                            _hoisted_24
                          ])
                        ])
                      ]),
                      _hoisted_25,
                      _createTextVNode(" " + _toDisplayString(_ctx.Teacher.assistantDetail.openAiAssistantId), 1)
                    ]))
              ]),
              (_ctx.Assistant)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _withDirectives(_createElementVNode("textarea", {
                        rows: "4",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Assistant.instruction) = $event)),
                        placeholder: "Asistanınız için kişisel talimatları girin.",
                        class: "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      }, null, 512), [
                        [_vModelText, _ctx.Assistant.instruction]
                      ]),
                      _hoisted_29,
                      _withDirectives(_createElementVNode("textarea", {
                        rows: "4",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.Assistant.behaviorStyle) = $event)),
                        placeholder: "Asistanınız davranış şeklini beltirleyin.",
                        class: "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      }, null, 512), [
                        [_vModelText, _ctx.Assistant.behaviorStyle]
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.UpdateAssistant && _ctx.UpdateAssistant(...args))),
                          class: "rounded-md bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        }, " Güncelle ")
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}